import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {AngularGridInstance, GridOdataService, GridOption} from 'angular-slickgrid';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
// import resizePolyfill from 'resize-polyfill';
import {ResizeEvent} from 'angular-resizable-element';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-create-ticket-citapp-cr',
  templateUrl: './create-ticket-citapp-cr.component.html',
  styleUrls: ['./create-ticket-citapp-cr.component.css']
})
export class CreateTicketCitappCrComponent implements OnInit {
    @Input() radioChecked: number;
    @Input() clientId: number;
    @Input() parrentTicketId = '';
    searchUser: FormControl = new FormControl();
    height: number;
    radioButton: any;
    reactiveSearchDisplay = false;
    preventiveRadioCheck = false;
    reactiveRadioCheck = false;
    subRadioDisplay = false;
    ticketTypes: any;
    searchField: string;
    name: string;
    desc: string;
    brief: string;
    rDate = '';
    dDate = '';
    urgency: number;
    impact: number;
    priority: string;
    notifier: NotifierService;
    respObject: any;
    urgencies = [];
    impacts = [];
    cat = [];
    searchCat = [];
    priorityId = 0;
    attachment = [];
    uploadButtonName = 'Upload File';
    fileUploadUrl: string;
    add = false;
    dynamicFields = [];
    priorityType: number;
    columnDefinitions = [];
    ticketColumnDefinitions = [];
    ticketColumn = [];
    columVal: string;
    descId: number;
    attrVal: string;
    gridOptions: GridOption;
    gridOptions2: GridOption;
    dataset: any[];
    angularGrid: AngularGridInstance;
    angularGrid2: AngularGridInstance;
    gridObj: any;
    gridObj2: any;
    selectedTitles = [];
    selectedTitles2 = [];
    Tickets = [];
    show: boolean;
    selected: number;
    data = [];
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    selectable = true;
    removable = true;
    addOnBlur = true;
    masterNameSelected: number;
    columnNameSelected: number;
    masterNameObj = [];
    columnNameObj = [];
    columnDataObj = [];
    columnValueObj = [];
    masterName: string;
    totalData: number;
    attrValue = [];
    columnData = [];
    start = 0;
    types = [];
    menus = [];
    totalItems: number;
    public modalRef: NgbModalRef;
    columnData2 = [];
    clientName: String;
    columnName: string;
    assetValue: string;
    page: number;
    collectionSize: number;
    pageSize: number;
    private subTypeSeq: string;
    private subTypeId: string;
    subtypes = [];
    searchTid: string;
    inciId: number;
    ticketCount: number;
    addedTicket = [];
    dataLoaded = false;
    ticketTypeLoaded = false;
    categoryLoaded = false;
    private baseCategories = [];
    private userAuth: Subscription;
    private ticketTypeSubscription: Subscription;
    hideAttachment: boolean;
    attachMsg: string;
    rsdbData: any;
    role = [];
    roleSelected: number;
    private roleId: number;
    isAnalyst: boolean;
    type: string;
    @ViewChild('loginName') private loginName;
    // @ViewChild('ticketcontent') private ticketcontent;
    empId: string;
    userGroups = [];

    ticketAllTypes: any;
    ticketDetails: any;
    solutions = [];
    tId: number;
    cat1: any;
    cat2: any;
    // @ViewChild('groupSelect') private groupSelect;
    private dialogRef: MatDialogRef<any, any>;
    userGroupSelected: number;
    userGroupId: number;
    private sourceType: string;
    private email: string;
    private mobile: string;
    private createbyId: string;
    private user: string;
    private psDetails: any;
    groupName: string;
    private selectedCatVal = 0;
    claimNo = '';
    hideClaim = true;
    searchDtls = [];
    panelOpenState = false;
    // @ViewChild('tab') private tab;
    selectedTab: number;
    allStatus = [];
    statusSelected: number;
    startDate: any;
    endDate: any;
    inciCategories = [];
    ticketIdSearchLoaded: boolean;
    filterSearchLoaded: boolean;
    isBlankRequester = false;
    isBlankDesc = false;
    isBlankLong = false;
    isBlankClaim = false;
    private storage: any;
    fromDate: string;
    toDate: string;
    minDate: any;
    maxDate: any;
    service: any;
    nextOffset = 0;
    searchPageSize: number;
    top: number;
    skip: number;
    query: any;
    isCreateTicket: boolean;
    assetCount = 0;
    hideCr: boolean;
    @Input() wfcresultId = '';
    @Input() displayed: boolean;
    @Input() typeSeq: number;
    @Input() userName: string;
    @Input() isLowestLevel: boolean;
    @Input() grpLevel: number;
    @Input() islead: boolean;
    @Input() parentTypeSeq: number;
    @Input() formdata: any;
    priorityArr = [];
    selectedPriority: number;
    userDtl = [];
    userSelected: string;
    isLoading = false;
    ticketAssetIds = [];
    plannedStartDt: any;
    plannedEndDt: any;
    scheduleStartDate: any;
    scheduleDuration: any;
    MAX_FILE_UPLOAD = 10;
    plannedTicketArr: any;
    plannedTicketDisplay: boolean;
    @Output() ticketLoader = new EventEmitter();
    is_approved_problem_ticket = 100;
    min: any;
    private attachFile: number;
    disabledCount: number;
    constructor(private _rest: RestApiService, notifier: NotifierService, private messageService: MessageService,
                private route: Router, private modalService: NgbModal, private dialog: MatDialog) {
        this.notifier = notifier;
    }

    angularGridReady(angularGrid: AngularGridInstance) {
        this.angularGrid = angularGrid;
        this.gridObj = angularGrid && angularGrid.slickGrid || {};
        this.columnData = this.gridObj.getColumns();
    }

    angularGridReady2(angularGrid: AngularGridInstance) {
        this.angularGrid2 = angularGrid;
        this.gridObj2 = angularGrid && angularGrid.slickGrid || {};
        this.columnData2 = this.gridObj2.getColumns();
    }

    ngOnInit() {
        this.attachFile = 0;
        this.totalItems = 0;
        this.plannedTicketDisplay = false;
        this.plannedStartDt = '';
        this.plannedEndDt = '';
        this.scheduleStartDate = '';
        this.scheduleDuration = '';
        this.page = 1;
        this.pageSize = 100;
        this.selectedPriority = 0;
        this.isAnalyst = false;
        this.hideAttachment = true;
        this.masterNameSelected = 0;
        this.userGroups = [];
        this.name = '';
        this.desc = '';
        this.brief = '';
        this.formdata = {clientId: this.clientId};
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        this.gridOptions = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableCheckboxSelector: true,
            enableRowSelection: true,
        };
        this.gridOptions2 = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableCheckboxSelector: true,
            enableRowSelection: true,
        };
        this.getTicketLoadingDataWithAttr();
        // this.getRSDBData('2');
        this._rest.getPriorityClientWise(this.clientId, this.radioChecked).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.details.unshift({
                    id: 0,
                    priority: 'Select Priority'
                });
                this.priorityArr = this.respObject.details;
            }
        });

        if (this.messageService.getUserId() === null || this.messageService.getToken() === null) {
            this.messageService.clearSession();
            window.location.href = this.messageService.API_ROOT;
        } else {
            this.sourceType = 'CR Portal';
            if (this.messageService.clientId) {
                this.clientId = this.messageService.clientId;
                this.clientName = this.messageService.client;
                this.userGroups = this.messageService.groupId;
                this.email = this.messageService.email;
                this.mobile = this.messageService.mobile;
                this.user = this.messageService.name;
                this.userName = this.messageService.loginName;
                // this.groupName = this.userGroups[0].grpName;
                // this.userGroupId = this.userGroups[0].groupId;
                if (this.userGroups !== undefined) {
                    if (this.messageService.getSupportGroup() === null) {
                        this.userGroupId = this.userGroups[0].groupId;
                        this.groupName = this.userGroups[0].grpName;
                        this.grpLevel = this.userGroups[0].level;
                    } else {
                        const group = this.messageService.getSupportGroup();
                        this.userGroupId = group.groupId;
                        this.groupName = group.grpName;
                        this.grpLevel = group.level;
                    }
                    this.userGroupSelected = this.userGroupId;
                }
            } else {
                this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                    this.clientId = auth[0].clientId;
                    this.clientName = auth[0].client;
                    this.userGroups = auth[0].groupId;
                    this.email = auth[0].email;
                    this.mobile = auth[0].mobile;
                    this.user = auth[0].name;
                    this.userName = auth[0].login_name;
                    // this.groupName = this.userGroups[0].grpName;
                    // this.userGroupId = this.userGroups[0].groupId;
                    if (this.userGroups !== undefined) {
                        if (this.messageService.getSupportGroup() === null) {
                            this.userGroupId = this.userGroups[0].groupId;
                            this.groupName = this.userGroups[0].grpName;
                            this.grpLevel = this.userGroups[0].level;
                        } else {
                            const group = this.messageService.getSupportGroup();
                            this.userGroupId = group.groupId;
                            this.groupName = group.grpName;
                            this.grpLevel = group.level;
                        }
                        this.userGroupSelected = this.userGroupId;
                    }
                    // }
                });
            }
        }

        this.searchUser.valueChanges.subscribe(
            psOrName => {
                this.isLoading = true;
                if (psOrName.length > 4) {
                    this._rest.searchUserDetails(this.clientId, psOrName).subscribe((res1) => {
                        this.respObject = res1;
                        this.isLoading = false;
                        if (this.respObject.success) {
                            this.userDtl = this.respObject.details;

                        } else {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.isLoading = false;
                        this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    this.isLoading = false;
                }
            });
        const todayDate = new Date();
        const todayMonth = todayDate.getMonth();
        const todayDay = todayDate.getDate();
        const todayYear = todayDate.getFullYear();
        this.min = new Date(todayYear, todayMonth, todayDay);
    }

    handleSelectedRowsChanged(e, args) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles = args.rows.map(idx => {
                const item = this.gridObj.getDataItem(idx);
                return item || '';
            });

            if (this.selectedTitles.length > 0) {
                this.show = true;
                this.selected = this.selectedTitles.length;
            } else {
                this.show = false;
            }
            // // console.log(JSON.stringify(this.selectedTitles));
        }
    }


    getTicketLoadingDataWithAttr() {
        this._rest.getCreateTicketData(this.messageService.getUserId(), this.radioChecked, this.clientId).subscribe((res) => {
            this.respObject = res;
            this.categoryLoaded = true;
            if (this.respObject.success) {
                // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
                this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                this.priorityType = this.respObject.details[0].val.type;
                this.ticketTypes = this.respObject.details[0].attribute;
                this.disabledCount = this.respObject.details[0].disabled;
                this.cat = [];
                this.subtypes = this.respObject.details[0].subtype;

                if (this.subtypes.length > 0) {
                    this.subtypes[0].checked = true;
                    if (this.subtypes[0].seq === 4) {
                        this.reactiveRadioCheck = true;
                        this.subRadioDisplay = true;
                        this.reactiveSearchDisplay = true;

                    } else if (this.subtypes[0].seq === 3) {
                        this.preventiveRadioCheck = true;
                        this.subRadioDisplay = true;
                        this.reactiveSearchDisplay = false;
                    }
                    // this.subTypeSeq = selectedButton.value.seq;
                    this.typeSeq = this.subtypes[0].seq;
                    this.subTypeId = this.subtypes[0].id;
                }
                this.cat = [];
                // this.clientId = this.respObject.details[0].clientId;
                this.respObject.details[0].val.urgency.unshift({
                    id: 0,
                    name: 'Select Urgency'
                });
                this.respObject.details[0].val.impact.unshift({
                    id: 0,
                    name: 'Select Business Impact'
                });
                this.urgencies = this.respObject.details[0].val.urgency;
                this.impacts = this.respObject.details[0].val.impact;
                this.urgency = 0;
                this.impact = 0;
                this.priority = '';
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    onCategoryChange(ticket, option) {
        // console.log(JSON.stringify(option), typeof option, JSON.stringify(ticket));
        // if(this.ticketTypes)

        const opt = JSON.parse(option);
        if (opt.type !== 'header') {
            // if (this.attachment.length > 0) {
            //   this.attachment = [];
            // }
            const value = opt.id;
            let matched = false;
            const index = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            // // console.log('index:' + index);
            const index1 = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            // const pid = this.ticketTypes[index1].options[0].id;
            // // console.log(this.ticketTypes[index1].options[0]);
            let pid;
            for (let i = 0; i < this.ticketTypes[index1].options.length; i++) {

                if (this.ticketTypes[index1].options[i].type) {
                    // console.log('inside');
                    pid = this.ticketTypes[index1].options[i].id;
                }
            }
            if (index1 === this.disabledCount) {
                // console.log('inside index'+this.cat.length);
                if (this.cat.length === 0) {
                    let pid1, cid1;
                    for (let i = 0; i < this.disabledCount; i++) {
                        pid1 = this.baseCategories[i].options[1].id;
                        cid1 = this.baseCategories[i].options[0].id;
                        this.cat.push({pid: pid1, cid: cid1});
                    }
                }
            }
            if (this.cat.length === 0) {
                this.cat.push({pid: pid, cid: value});
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({pid: pid, cid: value});
                } else {
                    for (let i = index; i < this.cat.length; i++) {
                        // // console.log('matched');
                        // // console.log(this.cat[i]);
                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }
            if (index > -1) {
                // console.log('index:' + index);
                for (let i = index + 1; i < this.ticketTypes.length; i++) {
                    const options = this.ticketTypes[i].options;
                    // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.ticketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }
            if (index === 2 && (this.typeSeq === 2)) {
                this.selectedCatVal = value;
                this.getRSDBData('1');
            }
            let cats = '';
            const catsArr = [];
            for (let i = 0; i < this.cat.length; i++) {
                if (this.cat[i].cid !== 0) {
                    catsArr.push(this.cat[i]);
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                }
            }
            for (let i = 0; i < catsArr.length; i++) {
                if (catsArr[i].cid !== 0) {
                    if (i === catsArr.length - 1) {
                        cats += catsArr[i].cid;
                    } else {
                        cats += catsArr[i].cid + ',';
                    }
                    // categoryName += this.cat[i].pid + '#' + this.cat[i].cid;
                }
            }
            this._rest.getTicketFieldsCatWise({
                clientId: this.clientId,
                catId: cats,
                ticketTypeId: this.radioChecked
            }).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // // console.log(JSON.stringify(this.respObject.details));
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        if (this.respObject.details[i].predifinedValue !== null) {
                            this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                            this.respObject.details[i].value = this.respObject.details[i].values[0];
                        } else {
                            this.respObject.details[i].value = '';
                        }
                    }
                    this.dynamicFields = this.respObject.details;
                    // console.log(JSON.stringify(this.dynamicFields));
                } else {
                }
            }, (err) => {
            });
            // // console.log('index:'+index);
            let data;
            if (index > -1) {
                // data = this.ticketTypes[index].options[0];
                for (let k = 0; k < this.ticketTypes[index].options.length; k++) {
                    if (this.ticketTypes[index].options[k].type) {
                        data = this.ticketTypes[index].options[k];
                    }
                }
                this.ticketTypes[index].options = [];
                this.dataLoaded = false;
            }

            this._rest.getAttributesParentWiseWithPriority(this.clientId, value, this.priorityType, this.radioChecked).subscribe((res) => {
                let respObject;
                respObject = res;
                // // console.log(JSON.stringify(this.respObject));

                if (respObject.success) {
                    this.dataLoaded = true;
                    if (respObject.details.val) {
                        // respObject.details.val.unshift(data);
                        // this.ticketTypes[index].options = respObject.details.val;
                        let singleValue = false;
                        if (respObject.details.val.length === 1) {
                            singleValue = true;
                        }
                        if (singleValue) {
                            respObject.details.val.push(data);
                        } else {
                            respObject.details.val.unshift(data);
                        }
                        this.ticketTypes[index].options = respObject.details.val;
                        if (singleValue) {
                            this.onCategoryChange(this.ticketTypes[index], JSON.stringify(respObject.details.val[0]));
                        }
                    }
                    if (respObject.details.priority) {
                        this.priority = respObject.details.priority.name;
                        this.priorityId = respObject.details.priority.id;
                    }
                } else {
                    this.dataLoaded = true;
                    if (index > -1) {
                        this.ticketTypes[index].options = [data];
                    }
                    // this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }

    getRSDBData(type) {
        this.rsdbData = [];
        this.selectedTab = 0;
        this._rest.getRSDBData(this.clientId, this.radioChecked, this.selectedCatVal,
            this.createbyId, this.createbyId, type).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.rsdbData = this.respObject.details;
            } else {
                // this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    searchFaq(value) {
        if (this.typeSeq === 2) {
            if (value.length > 2) {
                this._rest.getFaqSearchData(this.clientId, value, this.messageService.getUserId()).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.selectedTab = 1;
                        this.searchDtls = this.respObject.details;
                    }
                }, (err) => {
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            } else if (value.length === 0) {
                this.searchDtls = [];
            }
        }
    }

    resetField() {
        this.attachFile = 0;
        this.name = '';
        this.desc = '';
        this.brief = '';
        this.rDate = '';
        this.dDate = '';
        this.impact = 0;
        this.urgency = 0;
        this.attachment = [];
        this.hideAttachment = true;
        this.cat = [];
        this.selectedTitles2 = [];
        this.selectedTitles = [];
        this.claimNo = '';
        this.searchDtls = [];
        this.isBlankLong = false;
        this.isBlankDesc = false;
        this.isBlankRequester = false;
        this.isBlankClaim = false;
        this.priority = '';
        this.priorityId = 0;
        this.selectedCatVal = 0;
        this.selectedPriority = 0;
        // // console.log(JSON.stringify(this.baseCategories));
        this.ticketTypes = this.messageService.copyArray(this.baseCategories);
        this.Tickets = [];
        this.addedTicket = [];
        const progressbar = document.getElementById('progressbar');
        if (progressbar !== null && progressbar !== undefined) {
            progressbar.remove();
        }
        const fileLabel = document.getElementById('file-label');
        if (fileLabel !== null && progressbar !== undefined) {
            fileLabel.remove();
        }
        this.dynamicFields = [];
        this.plannedStartDt = '';
        this.plannedEndDt = '';
        this.scheduleStartDate = '';
        this.scheduleDuration = '';
        this.plannedTicketDisplay = false;
        this.userSelected = '';
    }

    timeFormat(date) {
        // console.log(date);
        if (date !== null && date !== 0 && date !== undefined) {
            const d = new Date(date);
            const utcdate = d.getUTCDate();
            const month = d.getUTCMonth() + 1;
            const year = d.getUTCFullYear();
            const hour = d.getUTCHours();
            const min = d.getUTCMinutes();
            // console.log('utc min' + min);
            let nHour, nMin;
            if (hour < 10) {
                nHour = '0' + hour;
            } else {
                nHour = hour;
            }
            if (min < 10) {
                nMin = '0' + min;
            } else {
                nMin = min;
            }
            return year + '-' + month + '-' + utcdate + ',' + nHour + ':' + nMin;
        } else {
            return '0000-00-00,00:00';
        }
    }

    createTicket() {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            let cats = '';
            let extrafields = '';
            let isError = false;
            let incIds = '';
            const assetIds = [];
            let extraCount = 0;
            let isAddFieldMissing = false;
            // console.log(JSON.stringify(this.cat));
            if (this.cat.length === this.ticketTypes.length) {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].cid !== 0) {
                        cats += this.cat[i].pid + '#' + this.cat[i].cid;
                        if (i !== this.cat.length - 1) {
                            cats += ',';
                        }
                    } else {
                        isError = true;
                        break;
                    }
                }
            } else {
                isError = true;
            }
            // // console.log(cats);
            // // console.log(JSON.stringify(this.dynamicFields));
            for (let j = 0; j < this.ticketAssetIds.length; j++) {
                assetIds.push(this.ticketAssetIds[j]);
            }

            for (let i = 0; i < this.dynamicFields.length; i++) {
                if (this.dynamicFields[i].value !== '' && this.dynamicFields[i].value !== 'NONE') {
                    extraCount++;
                    if (i === this.dynamicFields.length - 1) {
                        extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value;
                    } else {
                        extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value + '#';
                    }
                }
            }
            if (extraCount !== this.dynamicFields.length) {
                isAddFieldMissing = true;
            }
            extrafields = extrafields.substring(extrafields.length - 1, extrafields.length) === '#'
                ? extrafields.substring(0, extrafields.length - 1) : extrafields;
            // let noIncident = false;
            if (this.typeSeq === 5) {
                if (this.addedTicket.length > 0) {
                    for (let i = 0; i < this.addedTicket.length; i++) {
                        if (i === this.addedTicket.length - 1) {
                            incIds += this.addedTicket[i];
                        } else {
                            incIds += this.addedTicket[i] + ',';
                        }
                    }
                }
            }
            // if (noIncident) {
            //     this.notifier.notify('error', this.messageService.INCIDENT_ERROR);
            // } else {
            if (isError) {
                this.notifier.notify('error', this.messageService.CATEGORY_ERROR);
            } else if (isAddFieldMissing) {
                this.notifier.notify('error', this.messageService.ADDITIONAL_FIELD_ERROR);
            } else if (this.scheduleDuration <= 0 && this.plannedStartDt !== ''
                && this.plannedEndDt !== '' && this.scheduleStartDate !== '') {
                this.notifier.notify('error', 'Scheduled duration must be greater than zero.');
            } else if (this.plannedStartDt === '' || this.plannedEndDt === '' || this.scheduleDuration === '' ||
                this.scheduleStartDate === '') {
                this.notifier.notify('error', ' All the fields are mandatory');
            } else if (this.plannedStartDt > this.plannedEndDt) {
                this.notifier.notify('error', 'Planned end date must be greater than planned start date');
            } else {
                let data;
                const sourceType = this.messageService.getSourceType();
                if (sourceType !== null) {
                    this.sourceType = sourceType;
                }
                data = {
                    'ticket_type_seq': this.typeSeq,
                    'clientId': this.clientId,
                    'user_id': this.messageService.getUserId(),
                    'ticketTypeId': this.radioChecked,
                    // 'requesterInfo': this.name,
                    'tName': this.desc,
                    'longDesc': this.brief,
                    'attachmentPath': this.attachment,
                    'busi_priority_id': this.selectedPriority,
                    'tstatus': 1,
                    // 'requestedDate': this.rDate,
                    // 'dueDate': this.dDate,
                    'busi_impact_id': this.impact,
                    'busi_urgency_id': this.urgency,
                    'createdBy': this.createbyId,
                    'categoryDtlsLt': cats,
                    'priorityType': this.priorityType,
                    'sourceType': this.sourceType,
                    'original_createdbyid': this.messageService.getUserId(),
                    'userGroupId': this.userGroupId,
                    'planned_start_dt': this.timeFormat(this.plannedStartDt),
                    'planned_end_dt': this.timeFormat(this.plannedEndDt),
                    'schedule_start_date': this.timeFormat(this.scheduleStartDate),
                    'schedule_duration': this.scheduleDuration,
                    'is_approved_problem_ticket': this.is_approved_problem_ticket
                };
                if (!this.hideClaim) {
                    data['claimNo'] = this.claimNo;
                    if (this.claimNo.trim() === '') {
                        this.isBlankClaim = true;
                    } else {
                        this.isBlankClaim = false;
                    }
                }
                if (this.typeSeq === 1) {
                    data['requesterInfo'] = this.name;
                    if (this.name.trim() === '') {
                        this.isBlankRequester = true;
                    } else {
                        this.isBlankRequester = false;
                    }
                }
                if (this.desc.trim() === '') {
                    this.isBlankDesc = true;
                } else {
                    this.isBlankDesc = false;
                }
                if (this.brief.trim() === '') {
                    this.isBlankLong = true;
                } else {
                    this.isBlankLong = false;
                }
                if (this.typeSeq !== 1) {
                    data['requesterInfo'] = this.name;
                }
                // console.log('before : ' + JSON.stringify(data));
                if (!this.messageService.isBlankField(data)) {
                    // data['requestedDate'] = this.rDate;
                    // data['dueDate'] = this.dDate;
                    if (this.parrentTicketId !== '') {
                        data['parrent_id'] = this.parrentTicketId;
                    }
                    if (this.wfcresultId !== '') {
                        data['wfcclient_id'] = this.wfcresultId;
                    }
                    if (extrafields !== '') {
                        data['fieldValueDtls'] = extrafields;
                    }
                    if (assetIds.length > 0) {
                        data['assetIds'] = assetIds;
                    }
                    if (this.addedTicket.length > 0) {
                        data['incident_ticket_list'] = incIds;
                        // data['sub_ticket_type'] = this.subTypeId;
                    } else {
                        data['incident_ticket_list'] = '';
                    }
                    if (this.typeSeq === 3) {
                        data['sub_ticket_type'] = this.subTypeId;
                    }
                    data['psDetails'] = this.psDetails;
                    // console.log('create ticket data===' + JSON.stringify(data));
                    this.ticketLoader.emit({'dataLoaded': false});
                    // const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
                    if (this.attachFile > 0) {
                        this.notifier.notify('error', 'Please upload the file by clicking upload button before' +
                            ' clicking the create ticket button');
                        this.ticketLoader.emit({'dataLoaded': true});
                    } else {
                        this._rest.createTicket(data).subscribe((res) => {
                            this.respObject = res;
                            this.ticketLoader.emit({'dataLoaded': true});
                            if (this.respObject.success) {
                                const msg = this.respObject.id;
                                this.resetField();
                                if (this.parrentTicketId !== '') {
                                    this.messageService.setTicketData();
                                }
                                this.notifier.notify('success', 'Your Ticket id is: ' + msg);
                            } else {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            }
                        }, (err) => {
                            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                        });
                    }
                } else {
                    this.notifier.notify('error', this.messageService.BLANK_ERROR_MESSAGE);
                }
            }
        }
    }

    onFileComplete(data: any) {
        if (data.success) {
            this.hideAttachment = false;
            this.attachFile = 0;
            if (this.attachment.length > this.MAX_FILE_UPLOAD - 1) {
                this.attachMsg = 'More than ' + this.MAX_FILE_UPLOAD + ' files is not permitted';
            } else {
                this.attachment.push({originalName: data.fileName, fileName: data.changedName});
                console.log('this.attachment.length===' + this.attachment.length);
                if (this.attachment.length > 1) {
                    this.attachMsg = this.attachment.length + ' files uploaded successfully';
                } else {
                    this.attachMsg = this.attachment.length + ' file uploaded successfully';
                }
            }
        }
    }

    onUpload(data: any) {
        this.dataLoaded = data.loader;
    }

    ticketModal(contentData) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.ticketIdSearchLoaded = true;
            this.dataset = [];
            this.ticketColumnDefinitions = [
                {id: 'id', name: 'Id', field: 'id', minWidth: 100, sortable: true, filterable: true},
                {id: 'ticket_id', name: 'Ticket Id', field: 'ticket_id', minWidth: 100, sortable: true, filterable: true},
                {
                    id: 'type', name: 'Type', field: 'type', minWidth: 100, sortable: true, filterable: true
                },
                {
                    id: 'name',
                    name: 'Description',
                    field: 'name',
                    minWidth: 100,
                    sortable: true,
                    filterable: true
                },
                {
                    id: 'brief', name: 'Brief', field: 'brief', sortable: true, minWidth: 100, filterable: true
                }
            ];
            this.totalItems = 0;
            this.ticketCount = 0;
            this.modalRef = this.modalService.open(contentData, {size: 'lg'});
            this.modalRef.result.then((result) => {
            }, (reason) => {

            });
        }
    }

    clickRsdb(id: any) {
        this.tId = id;
        this._rest.getTicketDetailForRSDB(id, this.radioChecked).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.respObject.details.requestedDate =
                    this.messageService.datePipeFunc(this.respObject.details.requestedDate);
                this.respObject.details.dDate =
                    this.messageService.datePipeFunc(this.respObject.details.dDate);
                this.ticketDetails = this.respObject.details;
                this.messageService.setModalData(this.ticketDetails);
                // this.modalRef = this.modalService.open(this.ticketcontent, {size: 'lg'});
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    openTicketDetailsModal() {
        this.userSelected = '';
        const dialogRef1 = this.dialog.open(this.loginName, {
            width: '250px'
        });
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.data = [];
            this.columnDefinitions = [];
            this.masterNameSelected = 0;
            this.columnNameSelected = 0;
            this.assetValue = '';
            // ======================================= get asset master data =============================================
            this._rest.getAssetManagementMaster(this.clientId).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.masterNameObj = this.respObject.details;
                    this.masterNameObj.unshift({id: 0, masterName: 'Select asset master name'});
                    this.totalData = this.masterNameObj.length;
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
            this.assetCount = 0;
            this.modalRef = this.modalService.open(content, {size: 'lg'});
            this.modalRef.result.then((result) => {
            }, (reason) => {

            });
        }
    }

    getPriority() {
        let priorityType;
        if (this.psDetails) {
            priorityType = this.psDetails.SM;
        } else {
            priorityType = '';
        }
        this._rest.getPriorityForLTSSC(this.messageService.getUserId(), this.clientId,
            this.radioChecked, priorityType).subscribe((res) => {
            this.respObject = res;
            this.priority = '';
            this.priorityId = 0;
            if (this.respObject.success) {
                if (this.respObject.details.length > 0) {
                    this.priority = this.respObject.details[0].name;
                    this.priorityId = this.respObject.details[0].id;
                }
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    tabClick(event) {
        if (event.tab.textLabel === 'Solutions') {
            this.getSolutions();
        }
    }

    getSolutions() {
        this._rest.getSolutionsTicketWise(this.tId).subscribe((res1) => {
            this.respObject = res1;
            // // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                this.solutions = this.respObject.details;
            } else {
                // this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    onResizeEnd(event: ResizeEvent) {
        if (event) {
            // console.log(event);
            if (event.rectangle.height != null) {
                this.height = event.rectangle.height;
            }
        }
    }

    changeId($event) {
        this.sourceType = 'Call';
        this.name = this.userDtl[0].login_name + '-' + this.messageService.xorEncode(atob(this.userDtl[0].email),
            this.messageService.SECRET_TOKEN) +
            '-' + this.messageService.xorEncode(atob(this.userDtl[0].mobile), this.messageService.SECRET_TOKEN);
        this.createbyId = this.userDtl[0].id;
        this.getRSDBData('2');
        this.dialog.closeAll();
    }

    onFileError(msg: string) {
        console.log('upload error====' + msg);
        this.notifier.notify('error', msg);
    }

    changeRouting() {
        if (this.messageService.dashboardUrl !== undefined && this.messageService.dashboardUrl !== null) {
            this.messageService.changeRouting(this.messageService.dashboardUrl);
        }
        // this.route.navigate(['ticket/dashboard']);
    }

    onSubButtonChange(selectedButton) {
        if (this.attachment.length > 0) {
            this.attachment = [];
        }
        // // console.log(typeof selectedButton.value.seq,selectedButton.value.seq)
        if (selectedButton.value.seq === 4) {
            this.reactiveRadioCheck = true;
            this.subRadioDisplay = true;
            this.reactiveSearchDisplay = true;

        } else if (selectedButton.value.seq === 3) {
            this.preventiveRadioCheck = true;
            this.subRadioDisplay = true;
            this.reactiveSearchDisplay = false;
        }
        // this.subTypeSeq = selectedButton.value.seq;
        this.typeSeq = selectedButton.value.seq;
        this.subTypeId = selectedButton.value.id;
    }

    getTicketLoadingData() {
        this._rest.getTicketCreateLoadingDtls(this.messageService.getUserId(), this.radioChecked, this.clientId).subscribe((res) => {
            this.respObject = res;
            this.categoryLoaded = true;
            if (this.respObject.success) {
                // this.baseCategories = JSON.parse(JSON.stringify(this.respObject.details[0].attribute));
                this.baseCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                this.ticketTypes = this.respObject.details[0].attribute;

                this.priorityType = this.respObject.details[0].val.type;
                this.subtypes = this.respObject.details[0].subtype;
                // // console.log(this.priorityType);
                this.cat = [];
                // this.clientId = this.respObject.details[0].clientId;
                this.respObject.details[0].val.urgency.unshift({
                    id: 0,
                    name: 'Select Urgency'
                });
                this.respObject.details[0].val.impact.unshift({
                    id: 0,
                    name: 'Select Bussiness Impact'
                });
                this.urgencies = this.respObject.details[0].val.urgency;
                this.impacts = this.respObject.details[0].val.impact;
                this.urgency = 0;
                this.impact = 0;
                this.priority = '';
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    searchAssetmanagement(page) {
        this._rest.searchAssetManagementData(this.clientId, this.masterNameSelected,
            this.columnNameSelected, this.assetValue, this.page, this.pageSize).subscribe((res) => {
            this.respObject = res;
            // // console.log(this.respObject)
            if (this.respObject.success) {
                this.gridObj.getSelectionModel().setSelectedRanges([]);
                this.data = [];
                const data1 = [];
                for (let i = 0; i < this.columnData.length; i++) {
                    data1.push(this.columnData[i]);
                }
                const data = this.respObject.details;
                this.columnNameObj = data.columnObj;
                this.columnValueObj = data.valueObj;
                data1.push({id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true});
                data1.push({id: 'description', name: 'descriptionId', field: 'description', sortable: true, filterable: true});
                for (let i = 0; i < this.columnNameObj.length; i++) {
                    data1.push({
                        id: this.columnNameObj[i].columnName,
                        name: this.columnNameObj[i].columnName,
                        field: this.columnNameObj[i].id,
                        sortable: true,
                        filterable: true
                    });

                }
                this.gridObj.setColumns(data1);
                const colval = [];
                if (this.columnValueObj !== null) {
                    for (let j = 0; j < this.columnValueObj.length; j++) {
                        this.columVal = this.columnValueObj[j].columVal;
                        this.descId = this.columnValueObj[j].id;
                        const description = this.columnValueObj[j].description;
                        const columnValue = this.columVal.split(',');
                        // // console.log('column=', JSON.stringify(columnValue));
                        const jsonval = {};
                        jsonval['id'] = this.descId;
                        jsonval['description'] = description;
                        for (let k = 0; k < columnValue.length; k++) {
                            this.attrVal = columnValue[k];
                            this.attrValue = this.attrVal.split(':');

                            jsonval[this.attrValue[0]] = this.attrValue[1];
                        }
                        colval.push(jsonval);
                        this.collectionSize = this.columnValueObj[j].totalData;
                    }
                }
                this.data = colval;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    onMasterChange(value: any) {
        this.masterName = this.masterNameObj[value].masterName;
        // =================================== get column name================================
        this._rest.getAssetColumnByMaster(this.clientId, this.masterNameSelected).subscribe((res) => {
            this.respObject = res;
            // // console.log(this.respObject)
            if (this.respObject.success) {
                const data = this.respObject.details;
                this.columnDataObj = data;
                this.columnDataObj.unshift({columnId: 0, columnName: 'Select asset column name'});
                this.totalData = data.length;

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
        // =============================================================================================================
    }

    onClientChange(value: any) {
        this.columnName = this.columnDataObj[value].columnName;
    }

    submitAssetData() {
        this.searchAssetmanagement(this.page);
    }

    onPageChange(event) {
        this.page = event;
        this.searchAssetmanagement(this.page);
    }

    blockSpecialChar(e) {
        const k = e.keyCode;
        return ( k !== 35 && k !== 64);
    }

    saveData() {
        if (this.selectedTitles.length > 0 ) {
            for (let i = 0; i < this.selectedTitles.length; i++) {
                const jsonval = {};
                for (let j = 0; j < this.columnNameObj.length; j++) {
                    jsonval[this.columnNameObj[j].columnName] = this.selectedTitles[i][this.columnNameObj[j].id];
                }
                if (this.ticketAssetIds.indexOf(this.selectedTitles[i].id) === -1) {
                    this.Tickets.push(jsonval);
                    this.ticketAssetIds.push(this.selectedTitles[i].id);
                }
            }
            this.assetCount = this.Tickets.length;
        } else {
            this.notifier.notify('error', this.messageService.BLANK_ASSET);
        }
    }

    removeAsset(index) {
        this.Tickets.splice(index, 1);
        this.ticketAssetIds.splice(index, 1);
    }


    checkConflicket() {
        if (this.plannedStartDt > this.plannedEndDt) {
            this.notifier.notify('error', 'Planned end date must be greater than planned start date');
        } else {
            const startDate = this.timeFormat(this.plannedStartDt);
            const endDate = this.timeFormat(this.plannedEndDt);
            // console.log('...................... '+ startDate);
            this._rest.getTicketByPlannedDateTime(startDate, endDate, this.clientId).subscribe((res4) => {
                this.respObject = res4;
                // // console.log(this.respObject)
                if (this.respObject.success) {
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        this.respObject.details[i].planned_activity_start_dt =
                            this.messageService.datePipeFunc(this.respObject.details[i].planned_activity_start_dt);
                        this.respObject.details[i].planned_activity_end_dt =
                            this.messageService.datePipeFunc(this.respObject.details[i].planned_activity_end_dt);
                        this.respObject.details[i].schedule_start_date =
                            this.messageService.datePipeFunc(this.respObject.details[i].schedule_start_date);
                    }
                    this.plannedTicketArr = this.respObject.details;
                    if (this.plannedTicketArr.length > 0) {
                        this.plannedTicketDisplay = true;
                    }
                    //    console.log(this.respObject);

                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }

    searchTicket() {
        if (this.searchTid && this.searchTid !== '') {
            const data = {
                ticketId: this.searchTid, clientId: this.clientId
            };
            this.ticketIdSearchLoaded = false;
            this._rest.getTicketByIdMinimal(data).subscribe((res1) => {
                this.respObject = res1;
                this.ticketIdSearchLoaded = true;
                // // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                    this.gridObj2.getSelectionModel().setSelectedRanges([]);
                    this.searchTid = '';
                    this.dataset = this.respObject.details;
                    this.totalItems = this.respObject.details.length;
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else {
            alert(this.messageService.BLANK_TICKETID);
        }
    }

    addTicket() {
        for (let i = 0; i < this.selectedTitles2.length; i++) {
            if (this.addedTicket.indexOf(this.selectedTitles2[i].id) === -1) {
                this.addedTicket.push(this.selectedTitles2[i].id);
            }
        }
        this.ticketCount = this.addedTicket.length;
    }

    handleSelectedRowsChanged2(e, args) {
        console.log(args);
        if (Array.isArray(args.rows)) {
            this.selectedTitles2 = args.rows.map(idx => {
                const item = this.gridObj2.getDataItem(idx);
                return item || '';
            });
        }
    }

    saveReactiveProblemData() {
        // this.ReactiveData = this.selectedTitles2;
        this.modalRef.close();
    }

    removeReactiveProblemData(data): void {
        const index = this.addedTicket.indexOf(data);
        if (index >= 0) {
            this.addedTicket.splice(index, 1);
        }
    }

    onFileAttach() {
        this.attachFile = this.attachFile + 1;
    }

    onRemove() {
        this.attachFile = this.attachFile - 1;
    }
}
